module.exports = __webpack_public_path__ + "static/media/wrl-nola-logo@2x.90615fcd.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/wrl-nola-logo@2x.png
// module id = 1218
// module chunks = 0